import channelPartnerService from "reduxStore/service/channelpartnerService"; // created channel partner approve 
import {
  ADD_CHANNEL_PARTNER,
  CHANNEL_PARTNER_DETAIL,
  CHANNEL_PARTNER_ERROR,
  CHANNEL_PARTNER_FILTER,
  CHANNEL_PARTNER_LIST,
  CHANNEL_PARTNER_STATUS,
  CHANNEL_PARTNER_APPROVE,
  ADD_CP_TO_BUCKET,
  REMOVE_BUCKETDATA,
  REMOVE_CHECK_EMAIL_MOBILE,
  UPDATE_CHANNEL_PARTNER,
  CP_LIST_FOR_SM
} from "reduxStore/types";
import strings from "translate/language";
import { errorToast, successToast, unAuthorizedError } from "utils/httpClient";
import { CHECK_EMAIL_MOBILE, CP_CURRENT_MAPING, GET_SM_LIST } from "../types";

export const channelPartnerList = (item) => async (dispatch) => {
  try {
    const res = await channelPartnerService.channelPartnerList(item);
    if (res.data.status === 200) {
      dispatch({
        type: CHANNEL_PARTNER_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: CHANNEL_PARTNER_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const channelPartnerDetail = (item) => async (dispatch) => {
  try {
    const res = await channelPartnerService.channelPartnerDetail(item);
    if (res.data.status === 200) {
      dispatch({
        type: CHANNEL_PARTNER_DETAIL,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const channelPartnerFilter = (item) => async (dispatch) => {
  try {
    const res = await channelPartnerService.channelPartnerFilter(item);
    if (res.data.status === 200) {
      dispatch({
        type: CHANNEL_PARTNER_FILTER,
        payload: res.data,
      });
    } else {
      dispatch({
        type: CHANNEL_PARTNER_FILTER,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getAssignCPList = (item) => async (dispatch) => {
  try {
    const res = await channelPartnerService.getAssignCPList(item);
    if (res.data.status === 200) {
      dispatch({
        type: CHANNEL_PARTNER_FILTER,
        payload: res.data,
      });
    } else {
      dispatch({
        type: CHANNEL_PARTNER_FILTER,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

// export const channelPartnerStatusUpdate = (item) => async (dispatch) => {
//     try {
//         const res = await channelPartnerService.channelPartnerStatusUpdate(item);
//         if (res.data.status === 200) {
//             dispatch({
//                 type: CHANNEL_PARTNER_STATUS,
//                 payload: res.data,
//             });
//         }
//         else {
//             errorToast(res.data.message);
//         }
//     } catch (e) {
//         const { response = strings.initialError } = e;
//         unAuthorizedError(response.data);
//     }
// };
export const channelPartnerStatusUpdate = (item) => async (dispatch) => {
  try {
    const res = await channelPartnerService.channelPartnerStatusUpdate(item);
    if (res.data.status === 200) {
      dispatch({
        type: CHANNEL_PARTNER_STATUS,
        payload: res.data,
      });
      successToast(res.data.message);
      channelPartnerService.fireData(item)
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const addChannelPartner = (item) => async (dispatch) => {
  try {
    const res = await channelPartnerService.addChannelPartner(item);
    if (res.data.status === 200) {
      dispatch({
        type: ADD_CHANNEL_PARTNER,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getSMlist = (item) => async (dispatch) => {
  try {
    const res = await channelPartnerService.getSMlist(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_SM_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_SM_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const checkEmailMobile = (item) => async (dispatch) => {
  try {
    const res = await channelPartnerService.checkEmailMobile(item);
    if (
      res.data.status === 200 ||
      res.data.status === 201 ||
      res.data.status === 202
    ) {
      dispatch({
        type: CHECK_EMAIL_MOBILE,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const cpCurrentMaping = (item) => async (dispatch) => {
  try {
    const res = await channelPartnerService.cpCurrentMaping(item);
    if (res.data.status === 200) {
      dispatch({
        type: CP_CURRENT_MAPING,
        payload: res.data,
      });
    } else {
      dispatch({
        type: CP_CURRENT_MAPING,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};


export const channelPartnerApprove = (item) => async (dispatch) => {
  try {
    const res = await channelPartnerService.channelPartnerApprove(item);
    if (res.data.status === 200) {
      dispatch({
        type: CHANNEL_PARTNER_APPROVE,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const addCpToBucket = (item) => async (dispatch) => {
  try {
    const res = await channelPartnerService.addCpToBucket(item);
    if (res.data.status === 200) {
      dispatch({
        type: ADD_CP_TO_BUCKET,
        payload: res.data,
      });
    } else {
        dispatch({
          type: ADD_CP_TO_BUCKET,
          payload: [],
        });
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const removeAddCptoBucket = () => async (dispatch) => {
  try {
    dispatch({
      type: REMOVE_BUCKETDATA,
      payload: null,
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};


export const removeEmailMobileCheck = () => async (dispatch) => {
  try {
    dispatch({
      type: REMOVE_CHECK_EMAIL_MOBILE,
      payload: null,
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};


export const updateChannelPartner = (item) => async (dispatch) => {
  try {
    const res = await channelPartnerService.updateChannelPartner(item);
    if (res.data.status === 200) {
      dispatch({
        type: UPDATE_CHANNEL_PARTNER,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getCpSmList = (item) => async (dispatch) => {
  try {
    const res = await channelPartnerService.getCplistForSm(item);
    if (res.data.status === 200) {
      dispatch({
        type: CP_LIST_FOR_SM,
        payload: res.data,
      });
    } else {
      dispatch({
        type: CP_LIST_FOR_SM,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};


export const removeCpList = () => async (dispatch) => {
  try {
    dispatch({
      type: CHANNEL_PARTNER_FILTER,
      payload: [],
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};